import React, { useRef, useImperativeHandle, forwardRef } from "react";
import JoditEditor from "jodit-react";

const Editor = forwardRef((props, ref) => {
  const editorRef = useRef(null);
  const contentRef = useRef("");

  const config = {
    buttons: [
      "bold",
      "italic",
      "underline",
      "ul",
      "ol",
      "outdent",
      "indent",
      "font",
      "fontsize",
      "paragraph",
      "align",
      "undo",
      "redo",
      "link",
    ],
    removeButtons: [
      "image",
      "file",
      "video",
      "table",
      "cut",
      "copy",
      "paste",
      "hr",
      "eraser",
      "source",
      "dots",
      "speechRecognize",
      "fullsize",
    ],
    toolbarSticky: false,
  };

  useImperativeHandle(ref, () => ({
    getContent: () => contentRef.current,
    clearContent: () => {
      contentRef.current = "";
      if (editorRef.current) {
        editorRef.current.value = "";
      }
    },
  }));

  const handleBlur = (newContent) => {
    contentRef.current = newContent;
  };

  return <JoditEditor ref={editorRef} config={config} onBlur={handleBlur} />;
});

export default React.memo(Editor);
